const _ = require('./utils');

var BaseClass = function(attributes) {
	_.extend(this,attributes);
	if (this.initialize) {
        if (this.__proto__.initialize) {
            this.__proto__.initialize.apply(this,arguments);
        }
		this.initialize.apply(this,arguments);
	}
};

var extend = function(protoProps, staticProps) {
	var parent = this;
    var child;

    // The constructor function for the new subclass is either defined by you
    // (the "constructor" property in your `extend` definition), or defaulted
    // by us to simply call the parent constructor.
    if (protoProps && _.has(protoProps,'constructor')) {
      child = protoProps.constructor;
    } else {
      child = function(){ return parent.apply(this, arguments); };
    }

    // Add static properties to the constructor function, if supplied.
    _.extend(child, parent, staticProps);

    // Set the prototype chain to inherit from `parent`, without calling
    // `parent` constructor function.
    var Surrogate = function(){ this.constructor = child; };
    Surrogate.prototype = parent.prototype;
    child.prototype = new Surrogate();

    // Add prototype properties (instance properties) to the subclass,
    // if supplied.
    if (protoProps) _.extend(child.prototype, protoProps);

    // Set a convenience property in case the parent's prototype is needed
    // later.
    child.__super__ = parent.prototype;

    return child;
};

BaseClass.extend = extend;

module.exports = BaseClass;


/** WEBPACK FOOTER **
 ** ./src/utils/base-class.js
 **/